<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-flex align-items-center justify-content-between">
          <h4 class="mb-0 font-size-18">Detail {{module}}</h4>
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item">
                <a href="javascript: void(0);">Dashboard</a>
              </li>
              <li class="breadcrumb-item">
                <router-link :to="{name: table_module}">{{module}}</router-link>
              </li>
              <li class="breadcrumb-item active">Details</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <div class="row" v-if="dataLoad">
      <div class="col-lg-8">
        <div class="card">
          <div class="card-body">
            <div class="media align-items-center d-flex">
              <div class="avatar-md mr-3">
                <span class="avatar-title rounded-circle bg-soft-primary text-primary font-size-20">
                  <i class="bx bx-box"></i>
                </span>
              </div>
              <div class="media-body overflow-hidden">
                <span>{{data.srv_code}}</span>
                <h5 class="text-truncate font-size-18 mt-1">{{data.srv_name}}</h5>
                <p class="text-muted mb-0">
                  <router-link
                    :to="{name:'cars_model_detail', params: { uuid: data.crs_model_uuid }}"
                  >{{ data.crs_model_name }}</router-link>,
                  <router-link
                    :to="{name:'cars_brand_detail', params: { uuid: data.crs_brand_uuid }}"
                  >{{ data.crs_brand_name }}</router-link>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <h5 class="font-size-14">Price</h5>
            <p class="font-size-16 text-primary mb-0">
              <b>Rp {{$root.$root.numberWithCommas(data.srv_price)}}</b>
            </p>

            <h5 class="font-size-15 mt-4">Service Details :</h5>
            <p
              class="text-muted mb-0"
            >{{(data.srv_description != null) ? data.srv_description : '-'}}</p>
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center justify-content-between">
              <h4 class="card-title mb-0">Supplier</h4>
              <!-- <button
                type="button"
                class="btn btn-secondary waves-effect waves-light btn-sm right-bar-toggle"
              >
                <i class="bx bx-plus mr-2"></i> New Car
              </button>-->
            </div>
            <div class="mt-4" v-if="data.spr_id.length > 0">
              <div class="card border mb-2" v-for="(item, index) in data.spr_id" :key="index">
                <div class="card-body">
                  <div class="justify-content-between d-flex">
                    <div>
                      <h5 class="mb-1 font-size-15 text-truncate">
                        <router-link :to="{name:'supplier_detail', params:{uuid:item.spr_uuid}}">
                          {{ item.spr_name }}
                        </router-link>
                      </h5>
                      <span class="text-muted">Rp {{ $root.numberWithCommas(item.srv_price_external) }}</span>
                      <p class="text-muted mb-0 mt-3">{{ item.srv_description_external }}</p>
                    </div>
                    <!-- <div class="dropdown">
                      <button
                        class="btn btn-link dropdown-toggle px-0"
                        type="button"
                        id="dropdownMenuButton"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        <i class="bx bx-dots-vertical-rounded text-dark"></i>
                      </button>
                      <div
                        class="dropdown-menu dropdown-menu-right"
                        aria-labelledby="dropdownMenuButton"
                      >
                        <a class="dropdown-item" href="#">Edit</a>
                        <a class="dropdown-item" href="#">Delete</a>
                      </div>
                    </div> -->
                  </div>
                  <hr />
                  <div class="d-flex justify-content-between">
                    <div class>
                      <h5 class="font-size-12 text-muted">Phone</h5>
                      <p class="font-size-12 mb-0 font-weight-bold">{{item.spr_phone}}</p>
                    </div>

                    <div class>
                      <h5 class="font-size-12 text-muted">Email</h5>
                      <p class="mb-0 font-weight-bold">{{item.spr_mail}}</p>
                    </div>
                    <div class>
                      <h5 class="font-size-12 text-muted">Address</h5>
                      <p class="mb-0 font-weight-bold">{{item.spr_address}}</p>
                    </div>
                    <div class>
                      <h5 class="font-size-12 text-muted">Description</h5>
                      <p class="mb-0 font-weight-bold">{{item.spr_description}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex align-items-center w-100 bg-light mb-3 h-350 mt-4" v-else>
              <div class="m-auto text-center mini-stats-wid">
                <div
                  class="mini-stat-icon avatar-sm rounded-circle bg-secondary m-auto"
                >
                  <span class="avatar-title">
                    <i class="bx bx-search-alt font-size-2"></i>
                  </span>
                </div>
                <h5 class="mt-3">Data Empty</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="card">
          <div class="card-body">
            <h5 class="font-size-16">Estimate Durations</h5>
            <p class="text-muted mb-0">
              {{est_time(data.srv_time)}}
              <i class="bx bx-calendar-check ml-1 text-primary"></i>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      show: 10,
      page: 1,
      isLoading: false,
      module: "Regular Servis",
      table_module: "services",
      alias_table: "srv",
      uuid: this.$route.params.uuid,
      data: {},
      dataSearch: {},
      childDataLoaded: false,
      dataLoad: false,
      fields_trans: {},
      data_trans: {},
    };
  },
  mounted() {
    this.fetchDetail();
  },
  methods: {
    fetchDetail() {
      this.isLoading = true;
      this.axios
        .get("/" + this.table_module + "/detail/" + this.uuid)
        .then((response) => {
          this.isLoading = false;
          this.data = response.data.data;
          this.dataLoad = true;
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.response) {
            this.$toast.error("Data tidak ada");
            this.$router.push({ name: this.table_module });
          } else if (error.request) {
            console.log("Error", error.message);
          } else {
            console.log("Error", error.message);
          }
        });
    },
    qucikCreateShow(arm) {
      this.visible = arm;
    },
    est_time(arm) {
      var res = "";
      if (arm != null) {
        var arr = arm.split(":");
        res += arr[0] + " Hours ";
        res += arr[1] + " Minutes";
      }
      return res;
    },
  },
};
</script>